export class ScheduleNotes {
  iScheduleNotesId: number;
  iBusinessUnitId: number;
  strNotes: string;
  dateTimeDay:string;
}
